import React, { memo } from 'react';
import { getAvailableActions } from '../utils';
import { DownOutlined } from '@ant-design/icons';
import { Button, Col, Dropdown, Menu, Row } from 'components';
import { CommercialOfferActions, GENERATE_COMMERCIAL_OFFER } from 'models/CommercialOffer';
import styles from './styles.module.scss';

interface ActionButtonsProps {
  isRejected: boolean;
  status: string;
  paymentTerms?: string | Record<string, any>;
  onView: () => void;
  handleAction: (action: string) => void;
  isInFinalStatus: boolean;
}

export const ActionButtons: React.FC<ActionButtonsProps> = memo(
  ({ isRejected, status, paymentTerms, onView, handleAction, isInFinalStatus }) => {
    // Get the available actions based on status and payment terms
    const availableActions = getAvailableActions(status, paymentTerms as string);
    // Create menu items for all available actions
    const menuItems = availableActions
      .map((action) => {
        // Handle the special case for generate commercial offer
        if (action === GENERATE_COMMERCIAL_OFFER) {
          return (
            <Menu.Item key={action} onClick={() => handleAction(action)}>
              Generate Commercial Offer
            </Menu.Item>
          );
        }

        // Get the action from CommercialOfferActions
        const actionConfig = Object.values(CommercialOfferActions).find((a) => a.value === action);
        if (actionConfig) {
          return (
            <Menu.Item key={action} onClick={() => handleAction(action)}>
              {actionConfig.label}
            </Menu.Item>
          );
        }

        return null;
      })
      .filter(Boolean); // Remove null items

    const actionsMenu = <Menu>{menuItems}</Menu>;
    const hasActions = menuItems.length > 0;

    return (
      <Col span={24} className={styles.actions}>
        <Row gutter={[8, 8]}>
          <Col span={12}>
            <Button className={styles.viewButton} onClick={onView} block>
              View Offer
            </Button>
          </Col>
          <Col span={12}>
            <Dropdown overlay={actionsMenu} disabled={isRejected || !hasActions} trigger={['click']}>
              <Button
                type="primary"
                className={styles.actionButton}
                disabled={isRejected || !hasActions || isInFinalStatus}
                block
              >
                Actions <DownOutlined />
              </Button>
            </Dropdown>
          </Col>
        </Row>
      </Col>
    );
  }
);
